import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-flight-seat-booking',
  templateUrl: './flight-seat-booking.component.html',
  styleUrls: ['./flight-seat-booking.component.scss']
})
export class FlightSeatBookingComponent {

  @Output() confirmSeatSelection = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
  @Output() skipSelection = new EventEmitter<void>();

  confirmSelection() {
    this.confirmSeatSelection.emit();
    this.skipSelection.emit();
  }

  onBackButtonClick() {
    this.goBack.emit();
  }

  onClose() {
    this.close.emit();
  }

  @ViewChild('airlineSeats') airlineSeats: ElementRef;

  scrollSeats(direction: string): void {
    const scrollContainer = this.airlineSeats.nativeElement;

    if (direction === 'left') {
      scrollContainer.scrollLeft -= 100; // Adjust the scroll amount as needed
    } else if (direction === 'right') {
      scrollContainer.scrollLeft += 100; // Adjust the scroll amount as needed
    }
  }


  isSeatDetailsCollapsed = false;

  toggleSeatDetails() {
    this.isSeatDetailsCollapsed = !this.isSeatDetailsCollapsed;
  }

  flights = [
    { flightNumber: 'Flight 532', route: 'AMD - DEL', imageSrc: '/assets/image/dummy-airline.png' },
    { flightNumber: 'Flight 101', route: 'DEL - JFK', imageSrc: '/assets/image/dummy-airline.png' }
    // Add more flights as needed
  ];

  selectedFlight = this.flights[0]; // Select the first flight by default

  selectFlight(flight: any): void {
    this.selectedFlight = flight;
  }

}
